import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { StgApproveRequest } from '../../types/account'

const { ACCOUNTS_API_URL } = CONSTANT

const stgApproveAccount = async (payload: StgApproveRequest): Promise<unknown> => {
	const response = await fetchWithAuthorizationHeader(`${ACCOUNTS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'stg_approve'
		},
		body: JSON.stringify(payload)
	})

	const data = await response.json()
	if (data && typeof data === 'object' && 'error' in data && (data as { error?: string }).error) {
		throw new Error((data as { error: string }).error)
	}
	return data
}

export default stgApproveAccount
